import { useRef, useState } from 'react';
import { StoreImage } from '../../ui/StoreImage';

function Chevron({ dir }: { dir: 'left' | 'right' }) {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d={dir === 'left' ? 'M15 18l-6-6 6-6' : 'M9 18l6-6-6-6'} />
    </svg>
  );
}

export function ProductGallery({ images, alt }: { images: string[]; alt: string }) {
  const trackRef = useRef<HTMLDivElement>(null);
  const [index, setIndex] = useState(0);

  const onScroll = () => {
    const el = trackRef.current;
    if (!el || el.clientWidth === 0) return;
    setIndex(Math.round(el.scrollLeft / el.clientWidth));
  };

  const go = (i: number) => {
    const el = trackRef.current;
    if (!el) return;
    const n = Math.max(0, Math.min(images.length - 1, i));
    el.scrollTo({ left: n * el.clientWidth, behavior: 'smooth' });
  };

  if (images.length === 0) return null;

  return (
    <section className="cn-gallery" aria-label="Produktbilder">
      <div className="cn-gallery__track" ref={trackRef} onScroll={onScroll}>
        {images.map((src, i) => (
          <div className="cn-gallery__slide" key={`${src}-${i}`}>
            <StoreImage
              src={src}
              width={1080}
              alt={`${alt}, bild ${i + 1} av ${images.length}`}
              loading={i === 0 ? 'eager' : 'lazy'}
              decoding="async"
            />
          </div>
        ))}
      </div>

      {images.length > 1 && (
        <>
          <button type="button" className="cn-gallery__arrow cn-gallery__arrow--prev" onClick={() => go(index - 1)} disabled={index === 0} aria-label="Föregående bild">
            <Chevron dir="left" />
          </button>
          <button type="button" className="cn-gallery__arrow cn-gallery__arrow--next" onClick={() => go(index + 1)} disabled={index === images.length - 1} aria-label="Nästa bild">
            <Chevron dir="right" />
          </button>
          <div className="cn-gallery__dots">
            {images.map((_, i) => (
              <button
                key={i}
                type="button"
                className={i === index ? 'cn-dot is-active' : 'cn-dot'}
                aria-label={`Visa bild ${i + 1}`}
                aria-current={i === index ? 'true' : undefined}
                onClick={() => go(i)}
              />
            ))}
          </div>
        </>
      )}
    </section>
  );
}
